module.exports = __webpack_public_path__ + "static/img/bg-ar.3d8fbba9.png";